import { EventNames, ContentTypes } from "./useStandardizedTracking";
import { withUTMParams, utmReconciliationInfo } from "../urlFormatter";

// Fire a standardized LINK_CLICK (Pendo + Mixpanel, via useStandardizedTracking) for an
// AssistanceProgram outbound link. Keeps utm_content (= contentKey) / utm_source /
// destination_host in additional_info so in-app clicks reconcile 1:1 with the program's
// UTM analytics. `track` is the function returned by useStandardizedTracking().
export const trackApLinkClick = (track, { contentKey, url, featureGroup, assistanceProgram, potentialSaving } = {}) =>
  track(EventNames.LINK_CLICK, {
    contentType: ContentTypes.LINK,
    featureGroup,
    contentKey,
    assistanceProgram,
    potentialSaving,
    additionalInfo: utmReconciliationInfo(contentKey, url)
  });

// Track the click and open the UTM-tagged link in a new tab — for window.open call sites.
export const openTrackedApLink = (track, opts = {}) => {
  const taggedUrl = withUTMParams(opts.url, { content: opts.contentKey });
  // No destination → don't open about:blank, and don't record a click to nowhere.
  if (!taggedUrl) return;
  trackApLinkClick(track, opts);
  window.open(taggedUrl, "_blank", "noreferrer");
};
